export default __webpack_public_path__ + "static/media/icon-copy-testing.f2e19fec.svg";